import { log } from 'log';
import { usePushSubscription } from 'server';
import { useDispatch } from 'react-redux';

import { showGeoComplyPopupAction } from '../actions';

export const useOnACLRuleFailure = ({
    sdk,
    nextTime,
    triggerGeolocation,
    setTransactionID,
    setLicense,
    setNextTime,
    setShowOverlay,
    useTransparentPopup
}) => {
    const dispatch = useDispatch();

    usePushSubscription(31133, () => async (pushMessage) => {
        if (!sdk) {
            return;
        }

        const { action } = pushMessage.data;
        const actionType = Object.keys(action);

        if (actionType.includes('actionAclRulesFailedInfo')) {
            const { failedAclRuleParameters = [], userError = {} } = action.actionAclRulesFailedInfo ?? {};

            if (!failedAclRuleParameters.includes('GEOLOCATION_VALIDATED')) {
                return;
            }

            const { message } = userError;

            log('gcInfo', { event: 'actionAclRulesFailedInfo' });

            dispatch(showGeoComplyPopupAction({
                title: 'playtech.mobile.system.geocomply.popups.error.title',
                content: message,
                isModal: true,
                useTransparentPopup
            }));

            // unset current timeout
            setTransactionID(null);
            setLicense(null);
            setNextTime(0);
            setShowOverlay(false);

            await triggerGeolocation();
        }
    }, [sdk, nextTime, triggerGeolocation]);
};
